import { Form, Row, Col } from "react-bootstrap";
import type { ContactFormValues } from "../types";

export interface ContactFormProps {
  values: ContactFormValues;
  onChange: (next: ContactFormValues) => void;
}

export const ContactForm = ({
  values,
  onChange,
}: ContactFormProps): JSX.Element => {
  const set = <K extends keyof ContactFormValues>(
    key: K,
    v: ContactFormValues[K]
  ) => onChange({ ...values, [key]: v });

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="contact-name">Name</Form.Label>
            <Form.Control
              id="contact-name"
              type="text"
              required
              placeholder="Jane Smith"
              value={values.name}
              onChange={(e) => set("name", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="contact-title">Title</Form.Label>
            <Form.Control
              id="contact-title"
              type="text"
              placeholder="CEO"
              value={values.title}
              onChange={(e) => set("title", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="contact-email">Email</Form.Label>
            <Form.Control
              id="contact-email"
              type="email"
              placeholder="jane.smith@customer.com"
              value={values.email}
              onChange={(e) => set("email", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="contact-phone">Phone</Form.Label>
            <Form.Control
              id="contact-phone"
              type="text"
              placeholder="212-555-1234"
              value={values.phone}
              onChange={(e) => set("phone", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

export default ContactForm;
